/**
 * Lista de indicadores ambientales
 */
/** Código para identificar el pais */
const UBIGEO_NACIONAL = "00";
let INDICADORES = [];
const IndicadoresAmbientales = {
  /**
   * Obtener indicador ambiental
   *
   * @param {string} idIndicador
   * @returns {object}
   */
  get: function(idIndicador) {
    let indicador = {};
    INDICADORES.forEach((record) => {
      if (record.id == idIndicador) {
        indicador = record;
       }
    });
    if (!indicador) {
      throw new Error(
        `El ID de indicador #${idIndicador} no existe en INDICADORES_AMBIENTALES`
      );
    }
    return indicador;
  },
  /**
   * Obtener código de serie
   *
   * Devuelve el código de serie nacional o regional según sea el caso.
   *
   * @param {string} idIndicador
   * @param {string} idUbigeo Id de Region [01-25] o 00 para obtener la serie nacional
   * @returns {number} Código de serie
   */
  getSerie: function(idIndicador, idUbigeo) {
    let indicador = {};
    let esRegional=(idUbigeo!==UBIGEO_NACIONAL);
    INDICADORES.forEach((record) => {
      if(record.id===idIndicador){
        if (esRegional) {
          if(record.serieRegional){
            indicador = Object.assign({},record);
          }
         }else{
          if(record.serieNacional){
            indicador = Object.assign({},record);
          }
         }
      }
    });
    return indicador.id_serie;
  },
  getNombre(idIndicador) {
    return this.get(idIndicador).nombre;
  },
  getUnidad(idIndicador) {
    return this.get(idIndicador).unidad;
  },
  getFuente(idIndicador) {
    return this.get(idIndicador).fuente;
  },
  getFuenteAbrev(idIndicador) {
    let fuente = this.getFuente(idIndicador);
    return fuente;
  },
  /**
   *
   * @param {string} idTematica
   * @returns {object}
   */
  getIndicadoresPorTematica(idTematica) {
    var result = {};
    INDICADORES.forEach((indicador) => {
      if (indicador.idTematica === idTematica) {
        result[indicador.id] = indicador;
      }
    });
    return result;
  },
  /**
   * Obtener id de indicadores por temática ambiental
   *
   * @param {String} idTematica
   * @param {Number} idTematica
   * @returns {array}
   */
  getIdsIndicadoresPorTematica(idTematica, limit) {
    var result = [],
      i = 0;
      INDICADORES.forEach((indicador) => {
        if (indicador.idTematica === idTematica) {
          if (limit && i === limit) {
            return result;
          }
          result.push(indicador);
          i++;
        }
      });
    return result;
  },
  formatRawData(callback) {
    if (INDICADORES.length.length > 0) {
      callback(INDICADORES);
    } else {
      let indicador = {};
      fetch(window.Config.API_URL + "?querys=SNA09")
        .then((res) => res.json())
        .then(
          (result) => {
            if (result.success) {
              let SERVER_JSON_DATA = result.SNA09.data;

              let indicador_map = [];
              SERVER_JSON_DATA.forEach(function(child, k) {
                let _child = Object.assign({}, child);
                if (child.ambito == "Nacional") {
                  _child.serieNacional = child.id_serie;
                }
                if (child.ambito == "Departamental") {
                  _child.serieRegional = child.id_serie;
                }
                _child.id_serie=child.id_serie;
                _child.idTematica = child.tematica;
                _child.nombre = child.indicador;
                _child.fuente = child.fuente;
                _child.id = `${child.id_indicador}`;
                _child.unidad = child.unidad;
                _child.unidad_sigla = child.unidad_sigla;
                indicador_map.push(_child);
              });
              INDICADORES = indicador_map;
              callback(INDICADORES);
            } else {
              callback({});
            }
          },
          (error) => {
            callback({});
          }
        );
    }
  },
};
export default IndicadoresAmbientales;
